import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ADMIN_TOKEN_KEY = "bni-admin-token";
export const MEMBER_TOKEN_KEY = "bni-member-token";

function withToken(key) {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(key) || (key === ADMIN_TOKEN_KEY ? localStorage.getItem("bni-devadmin-token") : null);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
}

export const adminApi = withToken(ADMIN_TOKEN_KEY);
export const memberApi = withToken(MEMBER_TOKEN_KEY);

export function apiErr(e) {
  const d = e?.response?.data;
  if (d?.errors?.length) return d.errors.map((x) => x.message).join(" · ");
  if (typeof d?.detail === "string") return d.detail;
  if (d?.detail?.errors) return d.detail.errors.map((x) => x.message).join(" · ");
  if (e?.response?.status === 502) return "WhatsApp provider unreachable. Please try again.";
  return e?.message || "Request failed";
}

export const otpApi = {
  request: (phone) => axios.post(`${API}/auth/otp/request`, { phone }).then((r) => r.data),
  verify: (phone, code, request_id) => axios.post(`${API}/auth/otp/verify`, { phone, code, request_id }).then((r) => r.data),
  me: () => memberApi.get("/member/me").then((r) => r.data),
  uploadPhoto: (file) => {
    const fd = new FormData();
    fd.append("photo", file);
    return memberApi.post("/member/photo", fd).then((r) => r.data);
  },
  updateProfile: (body) => memberApi.patch("/member/profile", body).then((r) => r.data),
};

export const staffLogin = (phone, password, role) => axios.post(`${API}/auth/login`, { phone, password, ...(role ? { role } : {}) }).then((r) => r.data);
export const authLookup = (phone) => axios.post(`${API}/auth/lookup`, { phone }).then((r) => r.data);
export const forgotApi = {
  request: (phone, role) => axios.post(`${API}/auth/forgot/request`, { phone, role }).then((r) => r.data),
  verify: (phone, code, role, request_id) => axios.post(`${API}/auth/forgot/verify`, { phone, code, role, request_id }).then((r) => r.data),
  reset: (reset_token, new_password) => axios.post(`${API}/auth/forgot/reset`, { reset_token, new_password }).then((r) => r.data),
};
